module.exports = __webpack_public_path__ + "static/media/Band_Form_5.823b0578.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/24-25/Band_Form_5.pdf
// module id = 224
// module chunks = 0